import { packRecipeId } from './prepackCardModel'

// What an operator changed on one pack (#1089): the server records it in
// the pack's evaluation (`overrides.fields`), saving its schedule or
// template no longer changes those fields, and Reset gives them back.

// The fields, in the order the pack shows them, with their labels.
export const OVERRIDE_FIELDS = [
  ['template', 'Template'],
  ['colors', 'Colors'],
  ['picture', 'Picture'],
  ['title', 'Title'],
  ['surfaces', 'Surfaces'],
  ['legs', 'Legs'],
  ['status', 'Publishing'],
]

// The fields a pack of no schedule gives back to its template.
const TEMPLATE_FIELDS = new Set(['colors', 'picture'])

/**
 * The fields an operator changed on `pack`, as `[{ field, label }]` in
 * OVERRIDE_FIELDS order: every recorded one on a pack a schedule made, its
 * colors and picture on any other.
 */
export function overriddenFields(pack) {
  const fields = pack?.evaluation?.overrides?.fields
  if (!fields || typeof fields !== 'object') return []
  const fromSchedule = Boolean(packRecipeId(pack))
  return OVERRIDE_FIELDS
    .filter(([field]) => Object.hasOwn(fields, field) && (fromSchedule || TEMPLATE_FIELDS.has(field)))
    .map(([field, label]) => ({ field, label }))
}

// Where Reset gives a pack's fields back.
export const resetTarget = (pack) => (packRecipeId(pack) ? 'schedule' : 'template')

/**
 * The most recently updated of copies of one pack (nulls skipped), the first
 * of equally recent ones: a reset answers with a newer pack than the page
 * holds until it reads again, and the next reset must send that version.
 */
export function latestCopy(copies) {
  return copies.filter(Boolean).reduce((latest, copy) => (latest && !(Date.parse(copy.updated_at) > Date.parse(latest.updated_at)) ? latest : copy), null)
}
